import _ from 'lodash'
import highlight from 'scoreboard/components/highlight'


/**
 * Use to format the display of lists of items in the report.
 */
function prettyJoiner(arg) {
	var tokens = arg || []
	if (!(arg instanceof Array)) {
		tokens = [arg]
	}
	return _.map(tokens, function(value) { return highlight(value) }).join(', ')
}

export default prettyJoiner

prettyJoiner.__filename__ = 'reports/common/filter/pretty-joiner.js'
